import '../../OrganizationModals.scss';
import { Input, Modal } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from 'images/icons/Plus.svg';
import { useState } from 'react';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { useCreateNewClass } from 'queryHooks/Organization/Classes/useCreateNewClass';

type Props = {
  isOpen: boolean;
  close: () => void;
};

export const AddNewClass = ({ isOpen, close }: Props) => {
  const { t } = useTranslation();
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  const [newClassName, setNewClassName] = useState<string>('');
  const createClass = useCreateNewClass(selectedOrganizationId, { onSuccess: () => close() });

  const confirm = () => createClass.mutate({
    id: '',
    name: newClassName,
    organizationId: selectedOrganizationId,
    students: [],
    invites: [],
  });

  return (
    <Modal
      open={isOpen}
      onClose={close}
      className='organization-modal'
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => close(),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Create', { ns: 'organizationPage' }),
        onClick: () => confirm(),
        disabled: createClass.isPending || newClassName.length === 0,
      }}
      title={t('CreateNewClass', { ns: 'organizationPage' })}
      titleIcon={<PlusIcon />}
    >
      <div className='modal-body'>
        <p className='name-your-class'>
          <strong>{t('NameYourClass', { ns: 'organizationPage' })}</strong>
        </p>
        <Input
          label={t('ClassName', { ns: 'organizationPage' })}
          value={newClassName ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewClassName(e.currentTarget.value)}
        />
      </div>
    </Modal>
  );
};
